import styled from "styled-components";

export const ContainerCardGuardar = styled.div`
  width: 333px;
  border-radius: 8px;
  /* margin: auto; */
  box-shadow: 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
    0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
    0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
    0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
    0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
  background: white;
  border: ${({filaVirtual}) => filaVirtual ? "2px solid var(--color-broccoli)" : ""};
  .btn-aguardar {
    width: 225px;
    height: 37px;
    font-size: 18px;
    border: 2px solid var(--color-broccoli);
    color: var(--color-broccoli);
    background: transparent;
    font-weight: 700;
    border-radius: 8px;
    margin-top: 10px;
  }
  .btn-anunciarme {
    width: 130px;
    height: 37px;
    font-size: 18px;
    border: 2px;
    color: var(--color-white);
    background: var(--color-primary);
    font-weight: 500;
    border-radius: 8px;
    margin-top: 10px;
  }
  padding-bottom: 10px;
`;
export const TopCardGuardar = styled.div`
  padding-left: 10px;
  width: ${({filaVirtual}) => filaVirtual ? "330px" : "333px"};
  height: 45px;
  background: var(--color-secondary-gradient);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  color: var(--color-white);
  display: flex;
  justify-content: flex-starFt;
  align-items: center;
  font-weight: bold;
  gap: 10px;
  .circle {
    width: 25px;
    height: 25px;
    background-color: var(--color-broccoli);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 90%;
    /* border: 1px solid var(--color-black); */
  }
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  padding-left: 10px;
  gap: 10px;
  padding-top: 10px;
  span {
    font-size: 18px;
    font-weight: 400;
  }
  .bold {
    font-weight: bold;
  }
`;
